import { FormField, FormFieldType } from '@enroller/admissions-components';
import { Trans, useLingui } from '@lingui/react/macro';
import { Grid2, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import { Control } from 'react-hook-form';
import { useCountries } from '../contexts/CountryContext';
import { CourseReservation } from './CourseReservation';

interface StudentDetailsFormProps {
  control: Control<CourseReservation>;
}

export const StudentDetails = ({ control }: StudentDetailsFormProps) => {
  const { t } = useLingui();
  const { countries, loading } = useCountries();
  const theme = useTheme();

  return (
    <Grid2 container spacing={3} id="student-details">
      <Grid2 size={12}>
        <Typography variant="subtitle1">
          <Trans>Student Details</Trans>
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Student first name`} name="studentFirstName" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Student last name`} name="studentLastName" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Date} label={t`Student birthday`} name="studentDob" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          type={FormFieldType.Phone}
          label={t`Student phone`}
          name="studentPhone"
          control={control}
          placeholder={t`Enter phone number (including country code)`}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Student email`} name="studentEmail" control={control} />
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle1">
          <Trans>Student Address</Trans>
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Street address`} name="studentStreetAddress" control={control} maxLength={40} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }} sx={{ [theme.breakpoints.down('md')]: { display: 'none' } }}>
        {/* push 6 */}
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`City`} name="studentCity" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`State / Region / Province`} name="studentRegion" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Postal / Zip code`} name="studentPostalCode" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        {loading || countries === undefined ? (
          <Stack direction="column" justifyContent="flex-end" sx={{ height: '100%' }}>
            <Skeleton variant="rectangular" width="100%" height="48px" />
          </Stack>
        ) : (
          <FormField type={FormFieldType.Dropdown} label={t`Country`} name="studentCountry" options={countries} control={control} />
        )}
      </Grid2>
    </Grid2>
  );
};
